export const eventTypeOptions = [
  "Preparation",
  "Application",
  "Maintenance",
  "Monitoring",
  "Evaluation",
  "Measurement",
];
